import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker as DatePickerComponent } from '@mui/x-date-pickers/DatePicker';
import { pl, enUS } from 'date-fns/locale';
import { useLocale } from 'contexts/locale';
import useMessages from 'hooks/use_messages';

const DatePicker = (field) => {
  const messages = useMessages();
  const { locale } = useLocale();

  const handleDateChange = (date) => {
    if (date === null) {
      return field.onChange(null);
    }
    const timeZoneDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    field.onChange(timeZoneDate);
  };

  const adapterLocale = locale === 'pl' ? pl : enUS;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={adapterLocale}>
      <DatePickerComponent
        {...field}
        format={messages[locale].dateFormat}
        onChange={handleDateChange}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
